import { render, staticRenderFns } from "./WorkflowSteps.vue?vue&type=template&id=1bae8472&scoped=true"
import script from "./WorkflowSteps.vue?vue&type=script&lang=js"
export * from "./WorkflowSteps.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSteps.vue?vue&type=style&index=0&id=1bae8472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae8472",
  null
  
)

export default component.exports